import { useSelector } from 'react-redux';

import { STORAGE_KEYS } from '@constants/storage';
import { RoleType } from '@features/team-management/constants';
import { getLocalStorageItem } from '@utils/storage';

import { useGetLeadOrgConfigQuery } from '../queries/LeadManagementQuery';

/**
 * Org LMS rule: when `is_lead_assignment_allowed_for_agent` is false, sales agents
 * must not change assignee, use bulk assignee actions, or add leads (CSV, manual,
 * or Meta bulk sync). Meta lead ingestion is treated as bulk upload / lead
 * creation and is hidden together with other create paths while this applies.
 * Config is fetched only for the sales-agent role.
 */
const useLeadAgentAssigneeRestriction = () => {
  const organizationId = getLocalStorageItem(STORAGE_KEYS.ORGANIZATION_ID);
  const { rolesAndPermissions } = useSelector((state: any) => state.user);
  const isSalesAgent = rolesAndPermissions?.role === RoleType.SALES_AGENT;

  const { data: orgConfig, isLoading } = useGetLeadOrgConfigQuery(
    { organizationId: organizationId || '' },
    { skip: !organizationId || !isSalesAgent }
  );

  const isAssigneeSelectionDisabled =
    isSalesAgent && orgConfig?.is_lead_assignment_allowed_for_agent === false;

  return {
    orgConfig,
    isLoading,
    isSalesAgent,
    isAssigneeSelectionDisabled
  };
};

export default useLeadAgentAssigneeRestriction;
